import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import * as updateActions from '../actions/update-consent.actions';
import * as disableActions from '../actions/disable-consent.actions';
import { ConsentRestClient } from '../services/consent-rest-client.service';
import { Consent } from '../model/consent.model';
import { EnableConsent } from '../model/enable-consent.model';
import * as RouterActions from '../../../core/actions/router.actions';
import { AppMessage } from '../../../core/model/app-message.model';
import * as message from '../../../core/actions/message.actions';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/observable/of';
import { ModuleRoutingConstants } from '../../../core/helpers/module-routing.constants';

/**
 * Side effects related to Disable Consent there is no authorization process.
 */
@Injectable()
export class DisableConsentEffects {

    /**
     * Side effect to trigger enable consent.
     */
    @Effect() triggerEnableConsent$ = this.actions$
        .ofType(updateActions.DISABLE_CONSENT)
        .map(() => new disableActions.DisableConsentRequestAction());

    /**
     * Side effect to fire request to enable consent.
     */
    @Effect() addRequest$ = this.actions$
        .ofType(disableActions.DISABLE_CONSENT_REQUEST)
        .switchMap(() => this.disable());

    // -----------------------------------------------------------------------------------------------------------------

    /**
     * Side effect to leave the applications/manage and cards/manage.
     */
    @Effect() redirect$ = this.actions$
        .ofType(disableActions.DISABLE_CONSENT_SUCCESS)
        .mergeMap(() => [
            new message.MessageShowAction(AppMessage.newSuccessMessage('CONSENT.DISABLE-CONSENT.SUCCESS')),
            new RouterActions.Go({
                path: ModuleRoutingConstants.HISTORY_OF_REQUESTS_ROUTER
            })
        ]);

    // -----------------------------------------------------------------------------------------------------------------

    private disable = () =>
        this.client.updateConsent(<Consent>{consent: false})
            .map((res: EnableConsent) => (new disableActions.DisableConsentSuccessAction(res)))
            // If request fails, dispatch failed action
            .catch(error => Observable.of(new disableActions.DisableConsentErrorAction(error)))

    constructor(private client: ConsentRestClient,
                private actions$: Actions) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/effects/disable-consent.effects.ts